import React from 'react'
import {FormControl, FormLabel, Image} from 'react-bootstrap'
import calendar_icon from '../../../../assets/images/calendar.png'

class CustomDateInput extends React.Component {
  onChange(e) {
    // if the custom input does not provide the event as the first argument, it will fail
    // on a keyboard edit
    this.props.onChange(e)
  }
  render() {
    return (
      <FormLabel onClick={this.props.onClick}>
        <FormControl {...this.props} onChange={this.onChange.bind(this)} autocomplete="off" />
        <Image src={calendar_icon} className="calendar-image" alt="img" />
      </FormLabel>
    )
  }
}

export default CustomDateInput
